import { Col, Row } from 'react-dsgov';
import InfoCircleTooltip from '../infoCircleTooltip/infoCircleTooltip';
import style from './anmSwitch.module.scss';
import { useId } from 'react';

interface ISwitchProps {
  label: string;
  value: boolean;
  setValue: Function;
  tooltipText?: string;
  children?: React.ReactNode;
  switchDataTestId?: string;
  disable?: boolean;
  semMargem?: boolean;
}

const AnmSwitch = ({
  label,
  value,
  setValue,
  tooltipText,
  children,
  switchDataTestId,
  disable = false,
  semMargem = false,
}: ISwitchProps) => {
  const KEY_ENTER = 'Enter';
  const KEY_SPACE = ' ';
  const KEY_DOWN_TRIGGERS = [KEY_ENTER, KEY_SPACE];

  const LABEL_TRUE = 'Sim';
  const LABEL_FALSE = 'Não';

  const componentId = useId();

  const onClickEvent = () => {
    setValue(!value);
  };

  const onKeyDownEvent = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (KEY_DOWN_TRIGGERS.includes(event.key)) {
      setValue(!value);
    } else {
      event.stopPropagation();
    }
  };

  return (
    <Row className={semMargem ? style.anmSwitchContainerSemMargem : style.anmSwitchContainer}>
      <Col className={style.labelContainer}>
        {tooltipText && (
          <div className={style.tooltipContainer} data-testid='tooltip'>
            <InfoCircleTooltip text={tooltipText} id={componentId + '-tooltip'} />
          </div>
        )}
        <span id={componentId + '-label'} className={style.label}>
          {label}
        </span>
      </Col>

      <Col className={style.switchContainer}>
        <div
          className={`br-switch icon`}
          onClick={() => (disable ? undefined : onClickEvent())}
          onKeyDown={(event) => (disable ? undefined : onKeyDownEvent(event))}
          role='switch'
          aria-checked={value}
          tabIndex={0}
          data-testid={switchDataTestId}
          aria-disabled={disable}
        >
          {!disable && (
            <input
              id={componentId + '-switch-icon'}
              data-testid='switch-input'
              type='checkbox'
              checked={value}
              disabled={disable}
              aria-labelledby={componentId + '-label'}
            />
          )}
          <label className={style.labelSwitch} aria-hidden={true}>
            {value ? LABEL_TRUE : LABEL_FALSE}
          </label>
        </div>
      </Col>
    </Row>
  );
};

export default AnmSwitch;
